import { render } from "./LiveSection.vue?vue&type=template&id=6d478dc9"
import script from "./LiveSection.vue?vue&type=script&lang=js"
export * from "./LiveSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/florianroscher/Sites/simtschuk-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__